import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingCategory: false,
  isFetchingCategoryDocs: false,
  isFetchingForMemDoc: false,
  isFetchingGroups: false,
  isUpdating: false,
  isDeleting: false,
  isDownloading: false,
  isFetchingLatestDocuments: false,
  isFetchingProvidersDocument: false,
  isFetchingSpecsDocument: false,

  result: [],
};

const eligibilityDocumentsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_MEMBER_DOCUMENTS_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_MEMBER_DOCUMENTS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_MEMBER_DOCUMENTS_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.GET_DOCUMENT_CATEGORY_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCategory: true,
      };

    case types.GET_DOCUMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingCategory: false,
      };

    case types.GET_DOCUMENT_CATEGORY_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCategory: false,
      };

    case types.GET_CATEGORY_DOCS_FOR_MEMBER_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCategoryDocs: true,
      };

    case types.GET_CATEGORY_DOCS_FOR_MEMBER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingCategoryDocs: false,
      };

    case types.GET_CATEGORY_DOCS_FOR_MEMBER_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCategoryDocs: false,
      };

    case types.GET_CATEGORY_DOCS_FOR_MEM_DOC_PAGE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingForMemDoc: true,
      };

    case types.GET_CATEGORY_DOCS_FOR_MEM_DOC_PAGE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingForMemDoc: false,
      };

    case types.GET_CATEGORY_DOCS_FOR_MEM_DOC_PAGE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingForMemDoc: false,
      };

    case types.GET_DOCUMENT_GROUPS_AND_CATEGORIES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingGroups: true,
      };

    case types.GET_DOCUMENT_GROUPS_AND_CATEGORIES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingGroups: false,
      };

    case types.GET_DOCUMENT_GROUPS_AND_CATEGORIES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingGroups: false,
      };

    case types.UPDATE_DOCUMENT_CATEGORY_REQUEST:
      return {
        ...state,
        result: [],
        isUpdating: true,
      };

    case types.UPDATE_DOCUMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUpdating: false,
      };

    case types.UPDATE_DOCUMENT_CATEGORY_FAILURE:
      return {
        ...state,
        result: [],
        isUpdating: false,
      };

    case types.DELETE_MEMBER_DOCUMENT_REQUEST:
      return {
        ...state,
        result: [],
        isDeleting: true,
      };

    case types.DELETE_MEMBER_DOCUMENT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isDeleting: false,
      };

    case types.DELETE_MEMBER_DOCUMENT_FAILURE:
      return {
        ...state,
        result: [],
        isDeleting: false,
      };

    case types.DOWNLOAD_MEMBER_DOCUMENT_REQUEST:
      return {
        ...state,
        result: [],
        isDownloading: true,
      };

    case types.DOWNLOAD_MEMBER_DOCUMENT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isDownloading: false,
      };

    case types.DOWNLOAD_MEMBER_DOCUMENT_FAILURE:
      return {
        ...state,
        result: [],
        isDownloading: false,
      };

    case types.POST_LATEST_DOCUMENTS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingLatestDocuments: true,
      };

    case types.POST_LATEST_DOCUMENTS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingLatestDocuments: false,
      };

    case types.POST_LATEST_DOCUMENTS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingLatestDocuments: false,
      };

    case types.GET_PROVIDERS_DOCUMENT_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingProvidersDocument: true,
      };

    case types.GET_PROVIDERS_DOCUMENT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingProvidersDocument: false,
      };

    case types.GET_PROVIDERS_DOCUMENT_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingProvidersDocument: false,
      };

    case types.GET_SPECS_DOCUMENT_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingSpecsDocument: true,
      };

    case types.GET_SPECS_DOCUMENT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingSpecsDocument: false,
      };

    case types.GET_SPECS_DOCUMENT_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingSpecsDocument: false,
      };

    default:
      return state;
  }
};

export default eligibilityDocumentsReducer;
